import React from 'react';

export default () => (
    <div className="view-header">
        <header className="title text-white">
            <h1 className="h4 text-uppercase">Reports</h1>
            <p className="mb-0">Manifest per day</p>
        </header>
    </div>
);



// WEBPACK FOOTER //
// ./src/views/reports/view-header.js